<template>
  <WinnerInfoItem
    img-height="200"
    img-width="200"
    :placeholder="DOCTOR_IMG_PLACEHOLDER"
    :pd-link="doctor.link"
    :img-src="doctor.image"
    :img-alt="imageAlt"
    :certificate-url="doctor.certificate"
    @click:copy="emit('click:copy')"
  >
    <template #winner-name>
      {{ fullName }}
    </template>

    <template #winner-place>
      <slot name="winner-place">
        <v-img
          v-if="AWARD_ICONS[doctor.place as keyof typeof AWARD_ICONS]"
          class="mr-1"
          width="20"
          height="20"
          max-width="20"
          max-height="20"
          alt=""
          :src="AWARD_ICONS[doctor.place as keyof typeof AWARD_ICONS]"
        />
        <span>
          {{ doctor.place }} место
        </span>
      </slot>
    </template>

    <template #winner-location>
      <slot name="winner-location">
        {{ doctor.speciality }}, {{ regionName }}
      </slot>
    </template>
  </WinnerInfoItem>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { ISelectedDoctor } from '~/types/doctor'
import { DOCTOR_IMG_PLACEHOLDER } from '~/constants'
import { AWARD_ICONS } from '~/features/doctors/data/award-icons'

const props = defineProps({
  doctor: { type: Object as PropType<ISelectedDoctor>, required: true },
})

const emit = defineEmits(['click:copy'])

const mainStore = useMainStore()

const regionName = computed(() => mainStore.region?.name)

const fullName = computed(() => {
  const { surname, firstname, secondname } = props.doctor

  return `${surname} ${firstname} ${secondname}`
})

const imageAlt = computed(() =>
  `${fullName.value} - ${props.doctor.place} место по специальности ${props.doctor.speciality.toLowerCase()}`)
</script>
